import { type RefObject, useLayoutEffect, useState } from 'react';

type IUseIsPairWrappedProps = {
  containerRef: RefObject<HTMLElement | null>;
  firstItemRef: RefObject<HTMLElement | null>;
  secondItemRef: RefObject<HTMLElement | null>;
};

const useIsPairWrapped = ({ containerRef, firstItemRef, secondItemRef }: IUseIsPairWrappedProps) => {
  const [isWrapped, setIsWrapped] = useState(false);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const firstItem = firstItemRef.current;
    const secondItem = secondItemRef.current;

    if (!container || !firstItem || !secondItem) return;

    const checkWrap = () => {
      const firstRect = firstItem.getBoundingClientRect();
      const secondRect = secondItem.getBoundingClientRect();
      setIsWrapped(firstRect.height > secondRect.height);
    };

    checkWrap();

    const observer = new ResizeObserver(() => requestAnimationFrame(checkWrap));
    observer.observe(container);

    return () => observer.disconnect();
  }, [containerRef, firstItemRef, secondItemRef]);

  return isWrapped;
};

export { useIsPairWrapped };
